// frozen_string_literal: true

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["idInput", "nameInput", "nameDisplay", "button"]
  static values = {
    accessToken: String,
    webKey: String,
    appId: String,
    viewId: { type: String, default: "SPREADSHEETS" }
  }

  connect() {
    this.pickerApiLoaded = false
    this.loadPickerApi()
  }

  loadPickerApi() {
    // Load the Google API client and Picker libraries
    if (!window.gapi) {
      const script = document.createElement('script')
      script.src = 'https://apis.google.com/js/api.js'
      script.onload = () => {
        window.gapi.load('picker', () => {
          this.pickerApiLoaded = true
        })
      }
      document.head.appendChild(script)
    } else {
      window.gapi.load('picker', () => {
        this.pickerApiLoaded = true
      })
    }
  }

  openPicker() {
    if (!this.pickerApiLoaded) {
      console.error('Google Picker API not loaded yet')
      return
    }

    if (!this.accessTokenValue) {
      alert('Please connect your Google account first before selecting a file.')
      return
    }

    const view = new google.picker.DocsView(google.picker.ViewId[this.viewIdValue])
      .setIncludeFolders(true)
      .setSelectFolderEnabled(false)

    const builder = new google.picker.PickerBuilder()
      .setOAuthToken(this.accessTokenValue)
      .addView(view)
      .setDeveloperKey(this.webKeyValue)
      .setCallback(this.pickerCallback.bind(this))

    // App ID is optional - only needed to show files created by the app
    if (this.appIdValue) {
      builder.setAppId(this.appIdValue)
    }

    const picker = builder.build()

    picker.setVisible(true)
  }

  pickerCallback(data) {
    if (data.action === google.picker.Action.PICKED) {
      const doc = data.docs[0]
      const fileId = doc.id
      const fileName = doc.name

      // Set the file ID in the hidden field
      if (this.hasIdInputTarget) {
        this.idInputTarget.value = fileId
        this.idInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
      }

      // Set the file name in the hidden field
      if (this.hasNameInputTarget) {
        this.nameInputTarget.value = fileName
        this.nameInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
      }

      // Display the file name in the disabled input field
      if (this.hasNameDisplayTarget) {
        this.nameDisplayTarget.value = fileName
      }
    }
  }
}
